// BCP-932: the insights-views (BigQuery) side of the Looker migration.
//
// Looker served a whole dashboard from one request. insights-views serves one
// endpoint per chart, so a dashboard is a set of independently-failing slices.
// This registry is the single place that mapping lives — the saga fans out over
// it and the reducer builds its initial state from it, so adding an endpoint is
// one line.

export const DEMOGRAPHICS_SLICE_PATHS = {
  headcount: '/demographics/headcount',
  age: '/demographics/age',
  tenure: '/demographics/tenure',
  gender: '/demographics/gender',
  states: '/demographics/states',
};

export const ENROLLMENT_SLICE_PATHS = {
  cumulative: '/enrollments/cumulative',
  byBenefit: '/enrollments/by-benefit',
  medical: '/enrollments/medical',
  dental: '/enrollments/dental',
  vision: '/enrollments/vision',
};

export const COST_SLICE_PATHS = {
  summary: '/costs/summary',
  byMonth: '/costs/by-month',
  medicalByPlan: '/costs/medical/by-plan',
  dentalByPlan: '/costs/dental/by-plan',
  visionByPlan: '/costs/vision/by-plan',
  medicalByTier: '/costs/medical/by-coverage-tier',
  dentalByTier: '/costs/dental/by-coverage-tier',
  visionByTier: '/costs/vision/by-coverage-tier',
};

export const ENGAGEMENT_SLICE_PATHS = {
  uniqueVisitors: '/engagement/bennie-app/unique-visitors',
  inquiries: '/engagement/ask-bennie/inquiries',
  topCategories: '/engagement/ask-bennie/top-categories',
  userStatus: '/engagement/user-status',
  insuranceCardViews: '/engagement/insurance-card-views',
  perksCategories: '/engagement/perks-categories',
  otherAppEngagement: '/engagement/other-app-engagement',
};

/**
 * Dashboard id → slice name → path, appended to the client's
 * `/api/insights-views` base and its `/v1` version segment.
 *
 * A dashboard absent from this object has no BigQuery behind it, which is what
 * `BQ_CAPABLE_DASHBOARDS` in the page's `dataSource` module keys off.
 */
export const DASHBOARD_SLICE_PATHS = {
  demographics: DEMOGRAPHICS_SLICE_PATHS,
  enrollment: ENROLLMENT_SLICE_PATHS,
  cost: COST_SLICE_PATHS,
  engagement: ENGAGEMENT_SLICE_PATHS,
};

export const getSliceNames = id => Object.keys(DASHBOARD_SLICE_PATHS[id] || {});
